import { apiRequest } from '../api/http'
import type { ProductStock, ProductStockRow, StockUpdateRequest } from './types'

const PRODUCTS_BASE = '/api/products'

export function getProductStock(accessToken: string, productId: number): Promise<ProductStock> {
  return apiRequest<ProductStock>(PRODUCTS_BASE, `/${productId}/stock`, { accessToken })
}

export function updateProductStock(
  accessToken: string,
  productId: number,
  warehouseId: number,
  payload: StockUpdateRequest,
): Promise<ProductStockRow> {
  return apiRequest<ProductStockRow>(PRODUCTS_BASE, `/${productId}/stock/${warehouseId}`, {
    method: 'PUT',
    body: payload,
    accessToken,
  })
}
